import React from 'react';
import { Gamepad2, Users } from 'lucide-react';

interface GameCardProps {
  title: string;
  description: string;
  players: string;
  onClick: () => void;
  disabled?: boolean;
}

export function GameCard({ 
  title, 
  description, 
  players,
  onClick,
  disabled 
}: GameCardProps) {
  return (
    <div 
      onClick={disabled ? undefined : onClick}
      className={`game-card ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <div className="p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-medieval text-xl">{title}</h3>
          <Gamepad2 className="text-gold animate-torch w-6 h-6" />
        </div>
        
        <p className="text-parchment text-sm">{description}</p>
        
        <div className="flex items-center gap-4 text-sm">
          <div className="flex items-center gap-1 text-gold">
            <Users className="w-4 h-4" />
            <span>{players}</span>
          </div>
        </div>

        <div className="absolute top-0 right-0 w-16 h-16 opacity-10">
          <div className="w-full h-full bg-torch rotate-45 transform origin-top-right" />
        </div>
      </div>
    </div>
  );
}